 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import HALFTITLE from '@/components/Halftitle'
 import PAGE2 from '@/components/Page2'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import FOREWORD from '@/components/Foreword'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import INTRODUCTION from '@/components/Introduction'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER4 from '@/components/Chapter4'
 import CHAPTER5 from '@/components/Chapter5'
 import CHAPTER6 from '@/components/Chapter6'
 import BM from '@/components/BM'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Foreword",
 			"name" : "Foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/Acknowledgments",
 			"name" : "Acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js